var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _circle, _circle2, _path25, _path26, _path27, _path28, _path29;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg404Tv = function Svg404Tv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 319.75,
    height: 193,
    viewBox: "16.5 0 319.75 193",
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#231F20",
    d: "M45.825 186.532c-35.7 1.467-5.894 2.233 5.363 2.233 11.75 0 17.125-.354 34.543-.289-.043-2.735-2.268-2.045-10.643-2.295s-22.739.083-29.263.351zM276.221 184.716c-35.699 1.468-5.894 2.233 5.363 2.233 11.75 0 17.125 0 34.543.063 16.02 0 6.086-1.826-11.044-2.063-8.378-.118-22.338-.501-28.862-.233z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#313131",
    d: "M17.71 139.393a1405.763 1405.763 0 0 1 23.673-19.209 9451.876 9451.876 0 0 0 24.796-19.754c8.311-6.638 16.576-13.225 24.796-19.752a1430.31 1430.31 0 0 0 23.673-19.209l-17.36 76.243 18.823 4.286-4.286 18.822-18.823-4.285-7.272 31.941-19.584-4.459 7.272-31.941-55.708-12.683zm65.32-29.527a747.487 747.487 0 0 0-5.14 4.129 353.301 353.301 0 0 0-6.533 5.413 915.197 915.197 0 0 1-6.554 5.507c-2.14 1.782-3.798 3.204-4.971 4.269l17.872 4.068 5.326-23.386zM241.314 169.977a1422.703 1422.703 0 0 1 11.748-28.129 9865.166 9865.166 0 0 0 12.479-29.144c4.175-9.784 8.333-19.499 12.479-29.142 4.146-9.643 8.063-19.02 11.748-28.131l20.828 75.37 18.607-5.142 5.143 18.608-18.604 5.142 8.726 31.577-19.355 5.35-8.729-31.577-55.07 15.218zm43.54-56.945a676.302 676.302 0 0 0-2.567 6.071 344.182 344.182 0 0 0-3.188 7.858 937.521 937.521 0 0 1-3.162 7.955c-1.041 2.583-1.828 4.621-2.356 6.114l17.668-4.887-6.395-23.111z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#231F20",
    d: "M127.417 5.417s-2.583-.083-2.5 5.167S124.915 34 124.915 34s-.121 4.833 4.649 5 11.431.743 12.708-3.795c-.438-2.038-1.354-28.288-1.354-28.288l-13.501-1.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    d: "m134.421 4.615-4.375.042s-3.46-.169-3.458 5.208c.002 4 0 22.438 0 22.438s-.25 4.75 5.25 4.75h5.5s6.21.25 6.21-5.5v-22.5s-.059-4.292-4.064-4.375c-4.042-.084-5.063-.063-5.063-.063z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    d: "M134.999 8.375s-4.582-.625-4.749 4.042 4.817 4.5 4.817 4.5 4.533.536 4.683-4.064c.156-4.79-4.751-4.478-4.751-4.478z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    d: "M137.641 13.833s11.067-2.333 10.901 20.5.002 45.833.002 45.833S147.042 95.5 163.042 95.5c-.333-1.667 0-2.125 0-2.125s-13.235.125-12.701-13.208c.534-13.333 0-45.5 0-45.5s1.732-22.833-12.7-23c-1.516.083-1.493 2.199 0 2.166z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#AAA",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    d: "M214.223 48.616 198.938 84H203l12.305-35.054zM175.5 61.468l15.875 24.906L193.5 84.5l-17.125-23.75z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3F3F3",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    d: "M185.75 89.125s2-7.25 12.625-7.125 13.75 8.75 13.75 8.75-12.625-2.125-26.375-1.625z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#AAA",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    d: "M127.142 109.146s.525-7.229 21.525-8.063 65.5-.833 70.917-.417 10.52 1.521 12.385 11.386c.699-5.47.115-15.053-10.635-15.22s-76.5 1.5-76.5 1.5-17.167.751-17.692 10.814z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#231F20",
    d: "M168.151 186.352s-39.389.354-45.889.979-5.861 2.771 5.389 3.146 81.917-.928 103.688.063c15.125.688 8.563-3.313.188-3.563s-55.253-.736-63.376-.625z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2E2E2",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    d: "M240.813 110.725s1.019-18.348-14.189-20.375c0 0-43.652-5.865-89.62 1.816-14.14 2.363-21.009 5.658-20.886 35.48.123 29.82 1.501 40.009 1.501 40.009s.077 20.372 14.052 20.51c13.974.138 85.071.494 96.757.192 11.687-.303 14.052-13.371 13.974-26.517-.088-13.137-1.589-51.115-1.589-51.115zm-17.01 58.546c-7.701.195-78.566-.037-87.777-.127-9.211-.094-9.262-9.563-9.262-9.563s-1.049-21.546-1.05-41.204c-.001-13.801 6.859-17.984 16.279-18.74 30.98-2.479 80.622-1.012 80.622-1.012 10.023 1.336 9.354 13.43 9.354 13.43s.991 35.033 1.042 43.695c.052 8.663-1.507 13.322-9.208 13.521z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#3C71AA",
    stroke: "#231F20",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M221.285 173.62s-.651.339-1.26 2.478c-.756 2.656 2.134 4.381 4.349 3.775 2.215-.604 3.135-2.186 2.41-4.305-.627-1.834-2.479-3.257-5.499-1.948z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#5096E2",
    stroke: "#231F20",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M221.615 173.206s-1.59.795-1.413 2.737c.177 1.94 2.071 3.106 4.014 2.58 1.943-.528 2.786-1.784 2.521-3.463-.264-1.678-2.473-3.001-5.122-1.854z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#537029",
    stroke: "#231F20",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M211.134 174.662s-.444.232-.862 1.695c-.518 1.813 1.461 2.996 2.978 2.582 1.519-.414 2.146-1.496 1.646-2.945-.43-1.253-1.696-2.226-3.762-1.332z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#A5E051",
    stroke: "#231F20",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M211.359 174.378s-1.086.544-.967 1.873c.121 1.33 1.418 2.127 2.746 1.765 1.326-.358 1.902-1.221 1.725-2.367-.181-1.149-1.692-2.056-3.504-1.271z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#537029",
    stroke: "#231F20",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M202.657 174.809s-.445.232-.862 1.695c-.518 1.817 1.46 2.996 2.975 2.582 1.519-.414 2.146-1.495 1.648-2.945-.429-1.252-1.695-2.227-3.761-1.332z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#A5E051",
    stroke: "#231F20",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M202.882 174.525s-1.087.543-.967 1.873c.121 1.33 1.417 2.127 2.745 1.765 1.329-.362 1.906-1.222 1.724-2.368-.18-1.149-1.691-2.055-3.502-1.27z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#537029",
    stroke: "#231F20",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M193.898 174.809s-.444.232-.861 1.695c-.518 1.817 1.46 2.996 2.975 2.582 1.516-.414 2.146-1.495 1.649-2.945-.429-1.252-1.696-2.227-3.763-1.332z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#A5E051",
    stroke: "#231F20",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M194.125 174.525s-1.087.543-.966 1.873c.12 1.33 1.416 2.127 2.745 1.765 1.328-.362 1.904-1.222 1.724-2.368-.181-1.149-1.69-2.055-3.503-1.27z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m223.448 174.139.018 1.347M222.402 174.982s-.383.354-.241.926c.254 1.033 1.743.758 1.743.758s1.494-.234.713-1.696"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    d: "M119.291 177.533s2.168 6.592 10.793 6.717 98 .01 98 .01 11.667.407 13.23-9.333"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#231F20",
    d: "M120.541 180.604s4.043 3.35 7.626 3.705c3.583.357 67.667 0 67.667 0h33.333s7.64-.524 10.985-5.252c-.985 2.276-2.482 9.283-14.4 9.352-11.918.063-94.591-.258-94.591-.258s-7.247-.028-10.62-7.547z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2D133",
    stroke: "#231F20",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M131.333 172.902h7.179s1.946 0 1.946 2.658c0 3.707-.934 3.781-3.347 3.707-2.413-.078-5.586-.102-5.586-.102s-1.754.006-1.806-2.357c-.047-2.1-.333-3.906 1.614-3.906z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M131.978 175.063h5.865M131.978 176.24h4.897M131.978 177.417h5.865"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#E2E2E2",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    cx: 175.917,
    cy: 60.75,
    r: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#E2E2E2",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    cx: 214.674,
    cy: 49.132,
    r: 2.222
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#231F20",
    d: "M195.125 82.563s-3.999 1.89-1.625 3.812 7.813 1.834 7.813 1.834h-14.938c0-.001 2.975-5.288 8.75-5.646zM121.594 99.109s-4.881 5.558-3.488 44.224c1.184 34.199 4.255 34.869 7.269 37.229 4.708 3.688 20.23 2.709 54.928 3.736-7.136.031-35.533.256-50.626-.063-10.427.014-11.169-9.346-11.387-10.563-.218-1.212-6.477-65.701 3.304-74.563z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#231F20",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M135.067 22.354s-4.583-.285-4.75 4.382 4.817 4.5 4.817 4.5 4.533.536 4.683-4.064c.157-4.79-4.75-4.818-4.75-4.818z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M134.042 26.671v.58M136.266 26.671v.58"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M134.042 8.364s-2.187.594-2.229 4.135c0 2.532.885 3.746 1.739 4.236"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#231F20",
    d: "M129.875 11.188s-.936 3.656.438 6.156 5.187 1.563 5.952 1.094c.765-.469 3.324-2.625 3.404-3.219-1.076.656-2.482 1.969-4.326 1.656-1.844-.313-3.446.048-3.458-5.351.018-1.114 1.165-2.994 1.165-2.994s-2.425.564-3.175 2.658zM133.813 22.708s4.042-.958 4.958 3.708c.689 3.509-1.433 4.543-1.433 4.543s3.023-.815 2.416-4.904c-.65-4.367-5.315-3.54-5.941-3.347z"
  })));
};
export default Svg404Tv;